var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-fee-summary" },
    [
      _vm.isDataLoaded
        ? _c(
            "b-table-simple",
            {
              staticClass: "text-right",
              attrs: { borderless: "", responsive: "" },
            },
            [
              _c(
                "b-tr",
                { staticClass: "font-weight-bold" },
                [
                  _c("b-td", { staticClass: "label" }, [
                    _vm._v("\n                Streitwert\n            "),
                  ]),
                  _vm._v(" "),
                  _c("b-td"),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm.formatCurrencyCents(_vm.feeSummary.amountDispute)
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tr",
                [
                  _c("b-td", { staticClass: "label" }),
                  _vm._v(" "),
                  _c("b-td", [_vm._v("netto/neutral")]),
                  _vm._v(" "),
                  _c("b-td", [_vm._v("Summe")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tr",
                { staticClass: "font-weight-bold" },
                [
                  _c("b-td", { staticClass: "label" }, [
                    _vm._v("\n                Gesamtforderung\n            "),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(_vm.formatCurrencyCents(_vm.feeSummary.net.amount))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm.formatCurrencyCents(_vm.feeSummary.gross.amount)
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tr",
                { staticClass: "font-weight-bold text-success" },
                [
                  _c("b-td", { staticClass: "label" }, [
                    _vm._v("\n                Bereits gezahlt\n            "),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm.formatCurrencyCents(_vm.feeSummary.net.payments)
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm.formatCurrencyCents(_vm.feeSummary.gross.payments)
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tr",
                { staticClass: "font-weight-bold" },
                [
                  _c("b-td", { staticClass: "label" }, [
                    _vm._v(
                      "\n                Teil- / Gutschrift\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm.formatCurrencyCents(_vm.feeSummary.net.adjustment)
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(
                        _vm.formatCurrencyCents(_vm.feeSummary.gross.adjustment)
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tr",
                { staticClass: "font-weight-bold text-danger table-last-row" },
                [
                  _c("b-td", { staticClass: "label" }, [
                    _vm._v("\n                Offene Forderung\n            "),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(_vm.formatCurrencyCents(_vm.feeSummary.net.open))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-td", [
                    _vm._v(
                      _vm._s(_vm.formatCurrencyCents(_vm.feeSummary.gross.open))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }